import { useTranslation } from 'next-i18next';

/**
 * "문제를 풀 땐, 순서가 자동으로 섞여요" 안내.
 *
 * 저자는 보기를 **정답 순서대로** 입력하는데 그대로 학생에게 보이면 답이 노출되므로
 * 풀이 진입 시 클라가 섞는다. 이 안내가 없으면 저자가 "내가 입력한 순서가 그대로
 * 보이겠지"라고 오해한다.
 *
 * Figma 주석: "카드 포커스 상태일 때만 표시 (짝맞추기와 동일)" — 그래서 스타일을
 * MATCH 의 `build.match.shuffleHelper` 배너와 한 글자도 다르지 않게 맞췄다.
 * (rounded-sm 8px · border-alternative #e9eaf2 · py-2xs 6px · caption-lg-semibold · text-assistive)
 */
export const OrderShuffleNotice = () => {
  const {
    t
  } = useTranslation(['build']);
  return <div className="rounded-sm border border-alternative py-2xs text-center text-caption-lg-semibold text-assistive" data-sentry-component="OrderShuffleNotice" data-sentry-source-file="OrderShuffleNotice.tsx">
      {t('build:build.order.shuffleHelper')}
    </div>;
};